module.exports = __webpack_public_path__ + "media/images/brand/app_symbol_400-45900551bfe998b3155991448c3715ba.png";